import auth from "../../middlewares/auth";
export const seoManageRoute = [
  {
    path: '/seo-manage',
    component: () => import(/* webpackChunkName: "magazine_sliders" */ '../../views/settings/seo_manage/SeoContentList.vue'),
    name: 'seo_manage_index',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/seo-manage/create',
    component: () => import(/* webpackChunkName: "magazine_sliders" */ '../../views/settings/seo_manage/SeoManageForm.vue'),
    name: 'seo_manage_create',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/seo-manage/:id/edit',
    component: () => import(/* webpackChunkName: "magazine_sliders" */ '../../views/settings/seo_manage/SeoManageForm.vue'),
    name: 'seo_manage_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];